import constants from "../../../constants";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getDataFromStorage } from "../../../util";
import useAxiosPrivate from "../../useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import useCommonFunctionHooks from "../../useCommonFunctionHooks";
import { MockTestPageContext } from "../../../context/MockTestPageContext";
import MockTestLibraryHooks from "./MockTestLibraryHooks";

export default function MockTestDetailsHooks() {
  const Alert = useContext(AlertContext);
  const MockTestPageCxt = useContext(MockTestPageContext);

  const axios = useAxiosPrivate();
  const { handleSearch } = MockTestLibraryHooks();

  const { pathname } = useLocation();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  useEffect(() => {
    handleSearch();
  }, [MockTestPageCxt.searchText]);

  useEffect(() => {
    Alert.setIsLoaded(true);
    axios
      .get(
        `node/learner/mock/lib?bid=${localStorage.getItem("batchid")}&lid=${getDataFromStorage("learnerid")}&name=null`,
        // JSON.stringify({
        //   batchid: localStorage.getItem("batchid"),
        //   learnerid: getDataFromStorage("learnerid"),
        // }),
        getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.message,
          });
        } else {
          if (pathname === "/main/interview/library") {
            const videoQuestions = res.data.data.tests?.filter(
              (data) => data.aiMode === 1
            );

            MockTestPageCxt.setMockTest(videoQuestions || []);
            MockTestPageCxt.setSearchMockTest(videoQuestions || []);
          } else {
            const data = res.data.data.tests?.filter(
              (data) => data.aiMode !== 1 & data.videoqn===1
            );
            
            if (res.data.data.hasOwnProperty("paths")) {
              MockTestPageCxt.setMockTest(
                data?.concat(res.data.data.paths) || res.data.data.paths
              );
              MockTestPageCxt.setSearchMockTest(
                data?.concat(res.data.data.paths) || res.data.data.paths
              );
            } else {
              MockTestPageCxt.setMockTest(data);
              MockTestPageCxt.setSearchMockTest(data);
            }
          }
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  }, [pathname, MockTestPageCxt.dataRerender]);
}
